export default {
  mixpanelToken: '34ef83ffd76dbe88836281fc50d152c3',
  hcaptchaSiteKey: '018d304b-5ec3-4c3e-84e1-898ddf8cdec8',
};
